import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=6b3d89d9&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=6b3d89d9&prod&lang=css"
import style1 from "./Products.vue?vue&type=style&index=1&id=6b3d89d9&prod&lang=scss&scoped=true"
import style2 from "./Products.vue?vue&type=style&index=2&id=6b3d89d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3d89d9",
  null
  
)

export default component.exports